import Link from "next/link"
import { ClassValue } from "clsx"

import { baseUrl } from "@/lib/link-utils/link-utils"
import { cn } from "@/lib/utils"
import ImageWithFallback from "@/components/storyblok/common/ImageWithFallback"
import StoryblokAssetClient from "@/components/storyblok/common/StoryblokAssetClient"
import { AssetStoryblok } from "@/components/storyblok/component-types"

export default function HeaderLogo(props: {
  logo: AssetStoryblok | undefined
  subtext: AssetStoryblok | undefined
  sbLocale: string
  className?: string | ClassValue
  logoClassName?: string | ClassValue
  hideSubtext?: boolean
  customerLogoUrl?: string
  variant?: "default" | "rebrush"
}) {
  const isRebrush = props.variant === "rebrush"

  return (
    <div
      className={cn(
        isRebrush ? "flex shrink-0 grow-0" : "flex aspect-427/78 w-36 shrink-0 grow-0 lg:aspect-256/70 lg:w-64",
        props.className
      )}
    >
      <Link
        prefetch={false}
        className={cn(
          "inline-flex flex-col rounded-[2px] focus-visible:ring-2 focus-visible:ring-ub-hlblue focus-visible:outline-hidden",
          isRebrush && "h-full w-full justify-center"
        )}
        rel="home"
        href={baseUrl(true, props.sbLocale)}
        aria-label={"Start"}
      >
        {props.customerLogoUrl ? (
          <ImageWithFallback
            src={props.customerLogoUrl}
            alt={"logo"}
            className={cn(
              isRebrush
                ? "h-full w-full object-contain object-left"
                : "size-fit max-h-7 max-w-36 object-contain object-bottom-left lg:max-h-[70px] lg:max-w-64",
              props.logoClassName
            )}
            loading={"eager"}
            unoptimized={true}
          />
        ) : (
          <>
            <StoryblokAssetClient
              asset={props.logo}
              className={cn(
                isRebrush ? "h-auto max-w-full object-contain" : "aspect-427/78 object-contain",
                props.logoClassName
              )}
              loading="eager"
              width={isRebrush ? undefined : 427}
              height={isRebrush ? undefined : 78}
            />

            {!props.hideSubtext && (
              <StoryblokAssetClient
                asset={props.subtext}
                className="mt-2 aspect-412/24 object-contain pr-1.5 max-lg:hidden"
                width={412}
                height={24}
              />
            )}
          </>
        )}
      </Link>
    </div>
  )
}
